import { useQuery } from 'react-query'
import { AxiosInstance, AxiosResponse } from 'axios'

import { PATH } from '../../constants/global'
import { useAPI } from '..'
import { useMemo } from 'react'

async function getTotalsFromAPI(
   request: AxiosInstance
): Promise<AxiosResponse<TaskTotalsResponse>> {
   return request.get(PATH.DASHBOARD.NOTIFICATION_TOTALS, {
      params: {
         returnCompanyNotifications: false,
      },
   })
}

export default function useTaskTotals({
   enabled,
}: UseTaskTotalsOptions): UseTaskTotals {
   const request = useAPI()

   const { data, isLoading, isRefetching, refetch, isSuccess } = useQuery(
      ['task-totals'],
      () => getTotalsFromAPI(request),
      {
         enabled,
      }
   )

   const totalTasks = useMemo(() => {
      if (isSuccess && data?.data?.Data) {
         const {
            ActionTasks = 0,
            ReminderTasks = 0,
            InformationalTasks = 0,
         } = data.data.Data
         return ActionTasks + ReminderTasks + InformationalTasks
      } else {
         return 0
      }
   }, [data, isSuccess])

   return {
      isLoading: isLoading || isRefetching,
      refresh: refetch,
      totalTasks,
      isSuccess,
   }
}
